const news = [
  {
    id: 1,
    color: '#FEF3D0',
    accent: '#F5B730',
    icon: 'ri-leaf-line',
    date: 'Mar 15, 2026',
    title: 'New Spring-Summer Collection Arrived',
    description: 'Over 80 fresh pieces just landed in our store for the spring season. Come check them out before they\'re gone!',
  },
  {
    id: 2,
    color: '#D1F5E8',
    accent: '#3DBD8A',
    icon: 'ri-heart-line',
    date: 'Mar 5, 2026',
    title: 'Donation of the Month: 50 Families Helped',
    description: 'Thanks to your purchases and donations this month, we were able to help 50 families with quality clothing for their kids. Thank you!',
  },
  {
    id: 3,
    color: '#EDE8FA',
    accent: '#8A6FD8',
    icon: 'ri-star-line',
    date: 'Feb 22, 2026',
    title: 'Now Open Saturdays Until 5pm',
    description: 'Starting this month we\'ve extended our weekend hours so more families can visit us without rushing.',
  },
];

export default function NewsSection() {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-10">
          <span className="text-brand-purple text-xs font-600 uppercase tracking-widest" style={{ fontWeight: 600 }}>Latest Updates</span>
          <h2
            className="text-3xl font-700 text-gray-800 mt-1"
            style={{ fontFamily: "'Quicksand', sans-serif", fontWeight: 700 }}
          >
            Little Loop News
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {news.map(item => (
            <article
              key={item.id}
              className="rounded-2xl p-6 hover:scale-105 transition-transform duration-200 cursor-pointer"
              style={{ backgroundColor: item.color }}
            >
              <div className="flex items-center gap-3 mb-4">
                <div
                  className="flex items-center justify-center w-10 h-10 rounded-full"
                  style={{ backgroundColor: item.accent + '33' }}
                >
                  <i className={`${item.icon} text-xl`} style={{ color: item.accent }}></i>
                </div>
                <span className="text-xs text-gray-400">{item.date}</span>
              </div>
              <h3
                className="font-700 text-gray-800 mb-2 text-base"
                style={{ fontFamily: "'Quicksand', sans-serif", fontWeight: 700 }}
              >
                {item.title}
              </h3>
              <p className="text-sm text-gray-500 leading-relaxed">{item.description}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}